// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__ZmLVL","icon":"Checkbox_icon__P5WeC","label":"Checkbox_label__u1okt","error":"Checkbox_error__LQVzB"};